import { useEffect, useState } from 'react';

/**
 *
 * @param queries List of queries to match
 * @returns Boolean value telling if the passed query/queries is a matching.
 */
function useMediaQuery() {
  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  var _useState = useState(false),
    match = _useState[0],
    setMatch = _useState[1];
  for (var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++) {
    queries[_key] = arguments[_key];
  }
  var query = queries.join();
  useEffect(function () {
    var active = true;
    if (!supportMatchMedia) return undefined;
    var queryList = window.matchMedia(query);
    function updateMatch() {
      if (active) setMatch(queryList.matches);
    }
    updateMatch();
    queryList.addListener(updateMatch);
    return function () {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, supportMatchMedia]);
  return match;
}
export default useMediaQuery;